module.exports = __webpack_public_path__ + "img/5.38b380c1.png";